import React from 'react';
import styled from 'styled-components';

const RevenueBadgeContainer = styled.div`
  color: #2D882D;
  font-size: ${props => props.size === 'small' ? '0.8rem' : '1rem'};
  font-weight: 600;
  margin: ${props => props.size === 'small' ? '0.25rem 0' : '0.5rem 0'};
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #f8fafc;
  border: 2px solid #2D882D;
  padding: ${props => props.size === 'small' ? '0.3rem 0.8rem' : '0.5rem 1rem'};
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(45, 136, 45, 0.08);
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', monospace;
`;

const RevenueBadge = ({ revenue, size = 'medium', showIcon = true }) => {
  if (!revenue) return null;
  
  const formattedRevenue = parseFloat(revenue).toLocaleString('en-US', { 
    minimumFractionDigits: 0, 
    maximumFractionDigits: 0 
  });
  
  return (
    <RevenueBadgeContainer size={size}>
      {/* {showIcon && '💰'} */}
      Est. ${formattedRevenue}
    </RevenueBadgeContainer>
  );
};

export default RevenueBadge;